import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Box, Chip } from "@mui/material";
import { ArrowForward, CheckCircle, Warning } from "@mui/icons-material";

export default function TrafficOverview() {
  const navigate = useNavigate();
  const { analytics } = useSelector((state) => state.analytics);
  const overview = analytics?.data?.overview;

  const stats = [
    {
      label: "Total Sites",
      value: overview?.totalSites || 0,
      color: "#0073e6",
    },
    {
      label: "Active Sites",
      value: overview?.activeSites || 0,
      color: "#10b981",
    },
    {
      label: "Total Backups",
      value: overview?.totalBackups || 0,
      color: "#f59e0b",
    },
    {
      label: "Recent Deployments",
      value: overview?.recentDeployments || 0,
      color: "#8b5cf6",
    },
  ];

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2.5,
        flexGrow: 1,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2.5,
        }}
      >
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Platform Overview
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Current infrastructure status
          </Typography>
        </Box>
        <Button
          size="small"
          endIcon={<ArrowForward />}
          onClick={() => navigate("/dashboard/analytics")}
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          View Analytics
        </Button>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr 1fr", md: "1fr 1fr" },
          gap: 2,
          mb: 3,
        }}
      >
        {stats.map((stat) => (
          <Box
            key={stat.label}
            sx={{
              p: 2,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
              textAlign: "center",
            }}
          >
            <Typography
              variant="h4"
              fontWeight={700}
              sx={{ color: stat.color }}
            >
              {stat.value}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {stat.label}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {overview?.activeSites > 0 ? (
          <Chip
            icon={<CheckCircle sx={{ fontSize: 16 }} />}
            label="All systems operational"
            color="success"
            size="small"
            variant="outlined"
          />
        ) : (
          <Chip
            icon={<Warning sx={{ fontSize: 16 }} />}
            label="No active sites"
            color="warning"
            size="small"
            variant="outlined"
          />
        )}
      </Box>
    </Box>
  );
}
